import { render, staticRenderFns } from "./generic.vue?vue&type=template&id=dbf98740&scoped=true&"
import script from "./generic.vue?vue&type=script&lang=js&"
export * from "./generic.vue?vue&type=script&lang=js&"
import style0 from "./generic.vue?vue&type=style&index=0&id=dbf98740&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf98740",
  null
  
)

export default component.exports